var Acr = Acr || {};

Acr.HeroVideo = function () {
  var $heroVideo;
  var $playButton;
  var $videoTags;
  var $videoPlayerContainer;
  var $firstBackground;
  var $secondBackground;
  var videoPlayer;
  const hiddenClass = 'hidden';
  const playButtonSelector = '.js-play-button';
  const videoTagSelector = '.js-video-tag';
  const videoPlayerContainerSelector = '.js-video-player-container';
  const firstBackgroundSelector = '.js-first-background';
  const secondBackgroundSelector = '.js-second-background';
  const videoAsBackgroundClass = 'acr-hero-video--background';

  // Initialize all HTML selectors
  function initSelectors(element) {
    $heroVideo = element;
    $playButton = $heroVideo.querySelector(playButtonSelector);
    $videoTags = $heroVideo.querySelectorAll(videoTagSelector);
    $videoPlayerContainer = $heroVideo.querySelector(videoPlayerContainerSelector);
    $firstBackground = $heroVideo.querySelector(firstBackgroundSelector);
    $secondBackground = $heroVideo.querySelector(secondBackgroundSelector);
  }

  function initVideoPlayer() {
    if ($videoPlayerContainer) {
      var videoType = $videoPlayerContainer.getAttribute('data-video-type');
      var videoId = $videoPlayerContainer.getAttribute('data-video-id');
      var loop = $videoPlayerContainer.getAttribute('data-video-loop');
      var autoplay = $videoPlayerContainer.getAttribute('data-video-autoplay');
      var muted = $videoPlayerContainer.getAttribute('data-video-muted');
      var background = $heroVideo.classList.contains(videoAsBackgroundClass);

      if (videoType === 'vimeo') {
        videoPlayer = new Acr.VimeoPlayerManager.vimeoPlayerObject(videoId, $videoPlayerContainer, autoplay, background, loop, muted);
      } else {
        window.onYouTubeIframeAPIReady = function () {
          var container = $($videoPlayerContainer); // Convert the "videoPlayerContainer" into a jQuery object because it is necessary for the YouTube Manager
          videoPlayer = new Acr.YouTubeManager.YouTubePlayerObject(videoId, null, container, container, autoplay);
          videoPlayer.init();
        };
      }
    }
  }

  function bindEvents() {
    if ($playButton) {
      // Event for the play button
      $playButton.addEventListener('click', playButtonClickHandler);
      $playButton.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          playButtonClickHandler();
        }
      });
    }

    if ($videoTags.length > 0) {
      // Event triggered when MP4 video ends
      $videoTags.forEach(function (video) {
        video.addEventListener('ended', endedVideoHandler);
      });
    }
  }

  function playButtonClickHandler() {
    $firstBackground.classList.add(hiddenClass);
    $secondBackground.classList.remove(hiddenClass);
    $playButton.classList.add(hiddenClass);

    if ($videoTags.length > 0) {
      $videoTags.forEach(function (video) {
        video.classList.remove(hiddenClass);
        video.play();
      });
    } else {
      $videoPlayerContainer.classList.remove(hiddenClass);
      videoPlayer.play();
    }
  }

  function endedVideoHandler() {
    $videoTags.forEach(function (video) {
      video.classList.add(hiddenClass);
    });
    $secondBackground.classList.add(hiddenClass);
    $firstBackground.classList.remove(hiddenClass);
    $playButton.classList.remove(hiddenClass);
  }

  function init(element) {
    initSelectors(element);
    initVideoPlayer();
    bindEvents();
  }

  return {
    init: init,
  };
};
